// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Aotx","input":"styles_input__1m04t"};